var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaoTomeAndPrince(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9999C31.0455 39.9999 39.9998 31.0456 39.9998 19.9999C39.9998 8.95418 31.0455 -0.00012207 19.9998 -0.00012207C8.95412 -0.00012207 -0.000183105 8.95418 -0.000183105 19.9999C-0.000183105 31.0456 8.95412 39.9999 19.9998 39.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 13.0435H38.7559C35.9301 5.42744 28.5992 -6.10352e-05 19.9999 -6.10352e-05C14.477 -6.10352e-05 9.47752 2.23892 5.85846 5.85845L12.1739 13.0435Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 26.9564H38.7559C35.9301 34.5724 28.5992 39.9999 19.9999 39.9999C14.477 39.9999 9.47752 37.7609 5.85846 34.1414L12.1739 26.9564Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85782 5.85779C-1.95265 13.6683 -1.95265 26.3316 5.85782 34.1422C9.0854 30.9146 12.1895 27.8104 20 20L5.85782 5.85779Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3964 16.5217L26.2597 19.1789H29.0536L26.7933 20.821L27.6567 23.4782L25.3964 21.836L23.1361 23.4782L23.9993 20.821L21.7391 19.1789H24.533L25.3964 16.5217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0921 16.5217L34.9554 19.1789H37.7493L35.4891 20.821L36.3523 23.4782L34.0921 21.836L31.8317 23.4782L32.6951 20.821L30.4348 19.1789H33.2287L34.0921 16.5217Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaoTomeAndPrince);
export default __webpack_public_path__ + "static/media/sao_tome_and_prince.d1ebc76205a761e9eded6833ecb1fa0c.svg";
export { ForwardRef as ReactComponent };